import { FC, MouseEvent, useCallback, useMemo, useState, useRef } from 'react';
import Tippy from '@tippyjs/react';

import './drop-option.scss';
import { PortalMenuWrapper } from './PortalMenuWrapper';

interface IDropOption {
	options: {
		title: string | JSX.Element;
		icon?: string;
		handleOption?: () => void;
		disabled?: boolean;
		toolTip?: string;
		className?: string;
    value?: string;
	}[];
	menuIcon?: string;
  menuName?: string | JSX.Element;
  onClickOption?: (data: Record<string, any>) => void;
  className?: string;
}

export const DropOption: FC<IDropOption> = ({ options = [], menuIcon, menuName, onClickOption, className }) => {
	//local state for show drop options
	const [showMenu, setShowMenu] = useState<boolean>(false);
	const menuIconRef = useRef<HTMLDivElement>(null);

	const handleClick = useCallback((e: MouseEvent<HTMLDivElement>) => {
		e?.stopPropagation();
		setShowMenu(pre => !pre);
	}, []);

	const renderMenu = useMemo(
		() => (
			<div onClick={e => e.stopPropagation()} className="DropOption__list">
				{options.map(
					(option) => {
            const { title, icon, disabled = false, toolTip, handleOption, className } = option || {}
						if(disabled) {
							return null;
						}
						return(
						<Tippy
							key={title?.toString()}
							disabled={!toolTip}
							content={toolTip}
						>
							<div
								onClick={() => {
									if (!disabled) {
										setShowMenu(false);
										if (handleOption) handleOption();
                    if (onClickOption) onClickOption(option);
									}
								}}
								className={`DropOption__list-item ${
									disabled ? 'button--disabled' : ''
								} ${className}`}
							>
								{icon && <i className={`${icon} DropOption__item-icon`} />}
								{title}
							</div>
						</Tippy>
					)}
				)}
			</div>
		),
		[onClickOption, options]
	);

	return (
		<>
			<div className={`DropOption ${className}`}>
				<div 
					ref={menuIconRef}
					onClick={handleClick} 
					className="DropOption__menu-icon"
				>
          {!menuName && <i className={menuIcon || 'ri-more-2-fill'} />}
          {!!menuName && menuName}
				</div>
				<PortalMenuWrapper
					isVisible={showMenu}
					triggerRef={menuIconRef}
					onClose={() => setShowMenu(false)}
				>
					{renderMenu}
				</PortalMenuWrapper>
			</div>
		</>
	);
};
